<template>
  <ModalDefault header="y"
                modal_id="searchLeadsModal"
                size="modal-xl modal-dialog-scrollable"
                style_header=""
                :modal_header="`Pesquisar um contato`"
                footer="y"
                :method="searchLeads"
                icon="bx bx-search mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <!-- Básica-->
<!--      <div class="row pt-3 px-3">-->
<!--        <div class="col-12 px-4 bg-white shadow-sm">-->
<!--          Opções Básicas-->
<!--        </div>-->
<!--      </div>-->
      <div class="row pt-2 px-3">
        <div class="col-md-4">
          <label class="mb-0">{{ getTranslations('expression_42') }} </label>
          <div class="input-group mb-2">
            <input type="text" v-model="leads.search_lead.name" class="input_forms form-control">
          </div>
        </div>
        <div class="col-md-4">
          <label class="mb-0">{{ getTranslations('expression_54') }} </label>
          <div class="input-group mb-2">
            <input type="number" v-model="leads.search_lead.phone" class="input_forms form-control">
          </div>
        </div>
        <div class="col-md-4">
          <label class="mb-0">{{ getTranslations('expression_161') }} </label>
          <div class="input-group mb-2">
            <input type="email" v-model="leads.search_lead.email" class="input_forms form-control">
          </div>
        </div>
        <div class="col-md-4">
          <label class="mb-0">{{ getTranslations('expression_174') }} </label>
          <div class="input-group mb-2">
            <input type="text" v-model="leads.search_lead.office" class="input_forms form-control">
          </div>
        </div>
        <div class="col-md-4">
          <label class="mb-0">{{ getTranslations('expression_173') }} </label>
          <div class="input-group mb-2">
            <input type="text" v-model="leads.search_lead.company" class="input_forms form-control">
          </div>
        </div>
        <div class="col-md-4">
          <label class="mb-0">{{ getTranslations('expression_4') }} </label>
          <div class="input-group mb-2">
            <select @change="leads.search_lead.tags_id = []" v-model="leads.search_lead.channel_id" class="input_forms custom-select pl-50" style="min-width: 200px;">
              <option :value="null">{{ getTranslations('expression_123') }}</option>
              <option v-for="channel in channels.data" :key="channel.id" :value="channel.id">{{ channel.name }}</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Avançada-->
      <div class="row pb-2 pt-1 px-3">
        <div class="col-md-3">
          <label class="mb-0">{{ getTranslations('expression_67') }} </label>
          <div class="input-group mb-2">
            <select v-model="leads.search_lead.status_key" class="input_forms custom-select pl-50" style="min-width: 200px;">
              <option :value="null">{{ getTranslations('expression_903') }}</option>
              <option v-for="status in configs.data.lead_statuses" :key="status.id" :value="status.id">{{ status.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <label class="mb-0">{{ getTranslations('expression_160') }} </label>
          <div class="input-group mb-2">
            <select v-model="leads.search_lead.newsletter_key" class="input_forms custom-select pl-50" style="min-width: 200px;">
              <option :value="null">{{ getTranslations('expression_903') }}</option>
              <option v-for="newsletter in configs.data.lead_campaigns"
                      :key="newsletter.id"
                      :value="newsletter.id">
                {{ newsletter.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <label class="mb-0">{{ getTranslations('expression_537') }} </label>
          <div class="input-group mb-2">
            <input type="date"


                  onfocus="this.showPicker()"
                  onclick="this.showPicker()"
                   v-model="leads.search_lead.start_date"
                   min="" max=""
                   name="add_task_date"
                   class="form-control input_forms">
          </div>
        </div>
        <div class="col-md-3">
          <label class="mb-0">{{ getTranslations('expression_809') }} </label>
          <div class="input-group mb-2">
            <input type="date"


                  onfocus="this.showPicker()"
                  onclick="this.showPicker()"
                   v-model="leads.search_lead.final_date"
                   min="" max=""
                   name="add_task_date"
                   class="form-control input_forms">
          </div>
        </div>
      </div>
      <!-- Tags-->
      <div v-if="getTagsArray('channel_id', leads.search_lead.channel_id).length > 0 && leads.search_lead.channel_id > 0" class="row pt-0 mt-0 px-3">
        <div class="col-12 d-flex justify-content-between pb-2 cursor_default text-left ellipsis">
          <div class="row pl-3 pt-1 pb-2">
            <div class="col-12 b-block pb-4 pl-0">
              <label class="mb-0">{{ getTranslations('expression_187') }}</label>
            </div>
            <div class="col-12 text-center pb-2" style="display: contents;">
              <div v-for="tag in getTagsArray('channel_id', leads.search_lead.channel_id)"
                   :key="tag.id"
                   @click="selectTag(tag.id)"
                   class="chip mr-2 mb-3 cursor_pointer">
                <div class="chip-body">
                  <span style="font-size: .7rem;" class="chip-text pl-1">
                    {{ tag.name }}
                  </span>
                  <div class="chip-closeable" :class="leads.search_lead.tags_id.includes(tag.id) ? 'bg-success' : ''">
                    <i :class="leads.search_lead.tags_id.includes(tag.id) ? 'bx-check' : 'bx-x'" class="bx "></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-0 d-flex">
      <div>
          <div @click.prevent="clearSearch" data-dismiss="modal" class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3 mr-2">
            <span class="">{{ getTranslations('expression_810') }}</span>
          </div>
      </div>
      <div>
          <button type="submit" @click.prevent="searchLeads" data-dismiss="modal" class="shadow-sm cursor_pointer animated--grow-in btn-primary text-white py-2 px-3">
            <span class="">{{ getTranslations('expression_811') }}</span>
          </button>
      </div>
    </div>
  </ModalDefault>
</template>

<script>

import ModalDefault from "../../components/general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import $ from "jquery";

export default {
  name: "ModalSearchLead",
  components: {
    ModalDefault,
  },
  computed: {
    ...mapState(['me', 'configs', 'tags', 'chat', 'leads', 'channels', 'operators']),
    ...mapGetters([
      'getChannelObject',
      'getTagObject',
      'getTagsArray',
      'getLeadTagObject',
      'getDepartmentObject',
      'getLeadTagsArray',
      'getUserObject',
      'getOperatorObject',
      'getDepartmentsArray',
    ])
  },
  data() {
    return {
    }
  },
  methods: {
    selectTag(tag_id){
      if(this.leads.search_lead.tags_id.includes(tag_id)){
        const tagIndex = this.leads.search_lead.tags_id.findIndex(tag => {
          return tag === tag_id
        })
        this.leads.search_lead.tags_id.splice(tagIndex, 1)
      } else {
        this.leads.search_lead.tags_id.push(tag_id)
      }
    },
    clearSearch() {
      this.leads.search_lead = {
            name: "",
            phone: "",
            email: "",
            office: "",
            company: "",
            status_key: null,
            channel_id: null,
            start_date: null,
            final_date: null,
            newsletter_key: null,
            tags_id: []
      }
      this.searchLeads()
      this.leads.filter_leads_active = false
    },
    searchLeads(){
      this.$store.dispatch("getLeads", this.leads.search_lead)
      this.$store.dispatch('getLeadsInfo', this.leads.search_lead)
      this.leads.filter_leads_active = true
      $(`#searchLeadsModal`).modal('hide')
    }
  }
}
</script>

<style src="../../assets/css/pages/chat.css" scoped/>

<style scoped>

</style>
